export const KEY_1 = {
  ssj_app: {
    title: '旅游账本分享活动_主页',
    _position_: '旅游账本分享活动_主页',
    etype: 'view',
    page_name: '旅游账本站内'
  },
  ssj_h5: {
    title: '旅游账本分享活动_主页',
    _position_: '旅游账本分享活动_主页',
    etype: 'view',
    page_name: '站外分享活动'
  },
}
export const KEY_2 = {
  ssj_app: {
    title: '旅游账本分享活动_分享',
    _position_: '旅游账本分享活动_分享',
    etype: 'click',
    page_name: '旅游账本站内'
  },
  ssj_h5: {
    title: '旅游账本分享活动_分享',
    _position_: '旅游账本分享活动_分享',
    etype: 'click',
    page_name: '站外分享活动'
  },
}
export const KEY_3 = {
  ssj_app: {
    title: '旅游账本分享活动_活动规则',
    _position_: '旅游账本分享活动_活动规则',
    etype: 'click',
    page_name: '旅游账本站内'
  },
  ssj_h5: {
    title: '旅游账本分享活动_活动规则',
    _position_: '旅游账本分享活动_活动规则',
    etype: 'click',
    page_name: '站外分享活动'
  },
}
export const KEY_4 = {
  ssj_app: {
    title: '旅游账本分享活动_我的奖励',
    _position_: '旅游账本分享活动_我的奖励',
    etype: 'click',
    page_name: '旅游账本站内'
  },
  ssj_h5: {
    title: '旅游账本分享活动_我的奖励',
    _position_: '旅游账本分享活动_我的奖励',
    etype: 'click',
    page_name: '站外分享活动'
  },
}
export const KEY_5 = {
  ssj_app: {
    title: '旅游账本分享活动_开始抽奖',
    _position_: '旅游账本分享活动_开始抽奖',
    etype: 'click',
    page_name: '旅游账本站内'
  },
  ssj_h5: {
    title: '旅游账本分享活动_开始抽奖',
    _position_: '旅游账本分享活动_开始抽奖',
    etype: 'click',
    page_name: '站外分享活动'
  },
}
export const KEY_6 = {
  ssj_app: {
    title: '旅游账本分享活动_使用账本',
    _position_: '旅游账本分享活动_使用账本',
    etype: 'click',
    page_name: '旅游账本站内'
  },
  ssj_h5: {
    title: '旅游账本分享活动_使用账本',
    _position_: '旅游账本分享活动_使用账本',
    etype: 'click',
    page_name: '站外分享活动'
  },
}
